import { useAccountDataQuery } from 'queries/account';

export const useIsKnowledgeBaseFeatureEnabled = () => {
  const { data } = useAccountDataQuery();

  return data?.accountMeta?.features?.knowledgeBase ?? false;
};
